import { useEffect, useState } from "react";
import { UserAuth } from "../Context";
import referralLink from "../lib/referralLink";
import {
  BrandsSVG,
  ContactSVG,
  DiscoverSVG,
  FavoritesSVG,
  InviteFriendsSVG,
  MenSVG,
  PrivacySVG,
  ShoppingListSVG,
  TermsAndConditionsSVG,
  WomenSVG,
} from "../svgs";
import useModalStore from "../StatesStore/ModalStore";
import Links from "./Links";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../FirebaseConfig";
const Sidebar = () => {
  const { user } = UserAuth();
  const { openModal } = useModalStore();
  const [referralCode, setReferralCode] = useState("");
  const referralLinkURL = referralLink(referralCode);
  useEffect(() => {
    if (!user) return;
    const fetchReferralCode = async () => {
      try {
        const userDocRef = doc(db, "users", user?.uid);
        const docSnap = await getDoc(userDocRef);
        if (docSnap.exists()) {
          const userData = docSnap.data();
          if (userData && userData.referralCode) {
            setReferralCode(userData.referralCode);
          }
        }
      } catch (error) {
        console.error("Error fetching referral code:", error);
      }
    };

    fetchReferralCode();
  }, [user]);
  return (
    <div
      className="d-flex flex-column justify-content-between"
      style={{
        height: "-webkit-fill-available",
        width: "14.7vw",
        borderRight: "1px solid #EDEDED",
        position: "fixed",
        left: 0,
      }}
    >
      <div>
        <div
          className="d-flex flex-column"
          style={{ padding: "8px 0px 8px 20px" }}
        >
          <Links SVG={DiscoverSVG} text="Discover" route={`/`} />
          <Links SVG={BrandsSVG} text="Brands" route={`/brands`} />
          <Links SVG={MenSVG} text="Men" route={`/Men`} />
          <Links SVG={WomenSVG} text="Women" route={`/Women`} />
        </div>
        <hr style={{ margin: "4px 16px 4px 20px" }} />
        <div
          className="d-flex flex-column"
          style={{ padding: "8px 0px 8px 20px" }}
        >
          <Links
            SVG={ShoppingListSVG}
            text="Shopping Lists"
            route={`/userProfile/${user?.uid}/shoppinglist`}
          />
          <div onClick={() => openModal("Invite", "", referralLinkURL)}>
            <Links SVG={InviteFriendsSVG} text="Invite Friends" route={`#`} />
          </div>
          <Links
            SVG={FavoritesSVG}
            text="Favorites"
            route={`/userProfile/${user?.uid}/favorites`}
          />
        </div>
      </div>
      <div
        className="d-flex flex-column"
        style={{ padding: "8px 0px 8px 20px" }}
      >
        <Links
          SVG={ContactSVG}
          text="Contact Us"
          route="/staticPages/contactUs"
        />
        <Links
          SVG={PrivacySVG}
          text="Privacy Policy"
          route="/staticPages/privacyPolicy"
        />
        <Links
          SVG={TermsAndConditionsSVG}
          text="Terms of Service"
          route="/staticPages/termsAndConditions"
        />
      </div>
    </div>
  );
};

export default Sidebar;
